import { render, staticRenderFns } from "./RemoveApprovalDialog.vue?vue&type=template&id=763611b4"
import script from "./RemoveApprovalDialog.vue?vue&type=script&lang=js"
export * from "./RemoveApprovalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports